import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import momentJalaali from 'moment-jalaali';
import ReactTooltip from "react-tooltip";

toast.configure({
  autoClose: 4000,
  draggable: false,
  position: toast.POSITION.BOTTOM_CENTER,
  rtl:true

});
class Core extends React.Component{
    masks(type){
      if (type === 'price') return [/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/];
      if (type === 'credit') return [/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹,.,٫]/];
      if (type === 'shamsi_year') return [/[1,۱]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/];
      if (type === 'mobile') return [/[0,۰]/,/[9,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/,/[\d,۰,۱,۲,۳,۴,۵,۶,۷,۸,۹]/];
      return []
    }

    constructor(props) {
      super(props);
      this.lockScreen();
    }
    cancelRemove() {
      this.setState({ confirmation: false });
    }    
    httpPost(apiUrl, body = {}) {
      return new Promise((resolve, reject) => {
        fetch(apiUrl, {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => response.json())
        .then((dataHolder) => {
          resolve(dataHolder);
        })
        .catch((e) => { 
          reject(null);
        });
      });
    }
    /**
    @description یه مقدار رشته ای رو چک میکنه که خالی هست یا خیر
    @param {e} رشته ورودی
    @return {bool}
    */
    isBlank(e){
      if (e === null || e=== undefined || e == "" ) return true;
      return false;
    }

    /**
    @description نال یا تعریف نشده بودن یک مقدار رو چک میکنه
    @param {e} آبجکت ورودی
    @return {bool}
    */
    isNull(e){
      if (e === null || e=== undefined) return true;
      return false;
    }

    /**
    @description خالی بودن یک لیست رو بررسی میکنه
    @param {e} لیست ورودی ورودی
    @return {bool}
    */
    isEmpty(e){
      if (e === null || e === undefined) return true;
      if (e.length <= 0) return true;
      return false;
    }
    //هدایت به آدرس مورد نظر
    go(url){
      //جهت فعال شدن لودر
      this.state.form_data = null;
      //اگه تو روتینگ به صورت کامپوننت استفاده شده باشه و نه رندر میتونیم اجرا کنیم
      this.props.history.push(url);
    }
    //از روی ادرس فعلی صفحه ادرس صفحه برگشت رو محاسبه میکنه
    getReturnPath(){
      //ادرس مسیر جاری رو بدست میاره و اسم دامین و پروتکل رو از ادرس حذف میکنه
      var u = window.location.href.toString().replace(window.location.origin+'/organ/','/');

      if (u.substr(-1)!='/') u = u + "/";
      
      //چون ابتدا و انتها اسلش داریم داریم برای همین بایستی توجه بشه که اندیس اول و اخر ارایه خالی خواهد بو
      u = u.toLocaleLowerCase();
      let urlSections = u.split("/");
      // module/action/id

      return "/" + urlSections[1] + "/";
    }
    doRemove() {
      fetch(this.state.get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "remove",
          "id": this.state.id_to_remove
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((resualt) => {
        if (resualt.status == 1) {
          this.setState({ confirmation: false });
          this.setState({ id_to_remove: null });

            var u = window.location.href;
            if (u.substr(-1)!='/') u = u + "/";
            
            if (u.includes("/new/"))
              window.location.href = u.replace("/new/","");
            else
              if (u.includes("/edit/"))
                window.location.href = u.substring(0,u.indexOf("/edit/")) + "/";
              else
                this.refresh();          
        }
      }).catch(err=>this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger") );
    }
    remove(id) {
      this.state.id_to_remove = id;
      this.setState({ confirmation: true });
    }
    onSelectedRemove() {
      var selectedItems = "";
      for (var i = 0; i < this.state.selected_values.length; i++) {
        if (this.state.selected_values[i] != '') {
          if (selectedItems != "")
            selectedItems += ",";
          selectedItems += this.state.selected_values[i];
        }
      }
      if (selectedItems == "") {
        this.showToast("لطفا موارد مورد نظر برای حذف را انتخاب نمایید.","warning");
        return;
      }
      this.setState({ confirmationAll: true });
    }
    //برای اینکه یوزرهای قدیمی سایت شناسه هاشو و لینکهاشو تغییر نکنه از این رابطه برای تغییر آی دی ها در زمان مورد نیاز استفاده میشه
    getRealPersonId(realPerson){
      if (realPerson.person_id<170000)
        return realPerson.old_id_in_civilica;
      else
        return realPerson.person_id;
    }
    getLogObjectLink(log){
      if (log.object_type === 1 ) return <Link to={"/posts/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 2 ){ 
        if (log.log_sub_type === 1 || log.log_sub_type === 2)
          return <Link to={"/papers/edit/" + log.object_id + "/"}>مقاله [{log.object_title}]</Link>;
        if (log.log_sub_type === 3 || log.log_sub_type === 4)
          return <Link to={"/reports/edit/" + log.object_id + "/"}>طرح [{log.object_title}]</Link>;
        return <Link to={"/docs/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      }
      if (log.object_type === 3 ) return <Link to={"/realpersons/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 4 ){
        if (log.log_sub_type === 6)
          return <Link to={"/confs/edit/" + log.object_id + "/"}>کنفرانس [{log.object_title}]</Link>;
        if (log.log_sub_type === 7)
          return <Link to={"/journals/edit/" + log.object_id + "/"}>نشریه [{log.object_title}]</Link>;
        if (log.log_sub_type === 8)
          return <Link to={"/meetings/edit/" + log.object_id + "/"}>نشست [{log.object_title}]</Link>;
        if (log.log_sub_type === 50)
          return <Link to={"/conf/edit/" + log.object_id + "/"}>آرشیو [{log.object_title}]</Link>;
        if (log.log_sub_type === 51)
          return <Link to={"/issues/edit/" + log.object_id + "/"}>شماره نشریه [{log.object_title}]</Link>;
        if (log.log_sub_type === 52)
          return <Link to={"/calls/edit/" + log.object_id + "/"}>فراخوان [{log.object_title}]</Link>;
        return <Link to={"/legalpersons/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      }
      if (log.object_type === 5 ) return <Link to={"/staffs/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 6 ) return <Link to={"/requests/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 7 ) return <Link to={"/isiorders/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 8 ) return <Link to={"/cashes/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 10 ) return <Link to={"/onlinerecords/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 11 ) return <Link to={"/specialpersons/" + log.desc + "/edit" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 12 ) return <Link to={"/tickets/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 13 ) return <Link to={"/certificates/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 16 ) return <Link to={"/comment/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 17 ) return <Link to={"/isi/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 19 ) return <Link to={"/legalaccounts/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 21 ) return <Link to={"/subjects/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;
      if (log.object_type === 22 ) return <Link to={"/keywords/edit/" + log.object_id + "/"}>[{log.object_title}]</Link>;

      return "[" + log.object_title + "]";
    }
    genrateLogText(log){
      let h = [];
      if (log.log_type === 1 ) h.push(<i className="fa fa-plus text-green"></i>);
      if (log.log_type === 2 ) h.push(<i className="fa fa-pencil text-blue"></i>);
      if (log.log_type === 3 ) h.push(<i className="fa fa-trash text-red"></i>);
      if (log.log_type === 4 ) h.push(" ");
      if (log.log_type === 5 ) h.push(<i className="fa fa-laptop text-yellow"></i>);
      if (log.object_title === '' || log.object_title === null)
      {
        log.object_title = " با شناسه " + log.object_id;
      }

      if (log.log_sub_type === null)
        h.push(this.enumString(log.object_type,"object_type"));
      if (log.log_type !== 3)
        h.push(this.getLogObjectLink(log));
      else
        h.push("[" + log.object_title + "]");
        
      if (log.desc !== '' && log.object_type !== 11)
        h.push(" (" + log.desc + ")");
      return h;
    }
    renderRemoveBox(){
      if (this.state.form_data === null) return null;
      if (this.state.form_data.record[this.state.key] <= 0 ) return null;
      if (this.state.form_data.currentUser === null || this.state.form_data.currentUser === undefined) return null;
      if (this.state.form_data.currentUser.role !== 1 ) return null;
      
      return [
                this.getRemoveConfirmationModal()
              ,
                <div className="row">
                  <div className="col-md-12">
                    <div className="box box-info">
                      <div className="box-header with-border">
                        <h3 className="box-title">حذف کامل اطلاعات</h3>
                      </div>
                      <div className="form-horizontal">
                        <div className="box-body">
                          <div className="form-group">
                            {this.state.show_remove_button === false ?
                              <label className="col-sm-12 text-red">
                                <input type="checkbox" defaultChecked={false} onChange={e=>{this.setState({show_remove_button:e.target.checked})}} />
                                حذف کامل اطلاعات از روی دیتابیس سیستم
                              </label>
                            :
                              <label className="col-sm-12 text-center">
                                <a className="hand btn btn-danger" onClick={e => this.remove(this.state.form_data.record[this.state.key])}><i className="fa fa-trash"></i> حذف اطلاعات</a>
                              </label>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            ];
    }
    getRemoveConfirmationModal() {
      return (
        this.state.confirmation ?
          <div className="modal fade in show" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <p>آیا از حذف اطلاعات انتخابی مطئمن هستید؟</p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default pull-left" onClick={(e) => { this.cancelRemove(); }}>خیر</button>
                  <button type="button" className="btn btn-primary" onClick={(e) => { this.doRemove(); }}>بله</button>
                </div>
              </div>
            </div>
          </div>
          :
          this.state.confirmationAll ?
            <div className="modal fade in show" style={{ display: 'block' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <p>آیا از حذف اطلاعات انتخابی مطئمن هستید؟</p>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-default" onClick={(e) => { this.cancelRemoveAll(); }}>خیر</button>
                    <button type="button" className="btn btn-primary" onClick={(e) => { this.doRemoveAll(); }}>بله</button>
                  </div>
                </div>
              </div>
            </div>
            :
            null  
      )
    }
    getRealPersonAutocompleteTemplate(person){
      if (person === null) return null;
      return { 
                fullData: person,
                value: person.person_id, 
                label:<div>
                        <p>
                          <img className="img-circle" src={this.toImageUrl(person,"real_person")} style={{"width":"35px","height":"35px"}}/>
                          {person.fname} {person.lname}
                        </p>
                        <p>
                        {person.mobile}
                        {person.affiliation !=="" ? <small>({person.affiliation})</small> : null}
                        </p>
                    </div>
      }
    }
    getPartnerAutocompleteTemplate(person){
      if (person === null) return null;
      return { 
                value: person.person_id, 
                label:<div>
                        <i title="اطلاعات پایه موجود می باشد" className="fa fa-star text-yellow"></i>{person.name}
                      </div>
      }
    }
    render500(){
      return <section className="content">
                <div>
                  <div className="error-content">
                    <h3><i className="fa fa-warning text-red"></i> خطایی در سیستم رخ داده است</h3>
                    <p>
                      با عرض پوزش, خطایی در سامانه رخ داده است که قادر به اجرای درخواست شما نمی باشد.لطفا به مدیریت سیستم اطلاع دهید
                    </p>
                  </div>
                </div>
              </section>
    }
    render404(){
      return <section className="content">
                <div>
                  <div className="error-content">
                    <h3><i className="fa fa-warning text-red"></i> صفحه مورد نظر یافت نشد</h3>
                    <p>
                      با عرض پوزش, صفحه و یا آدرس درخواستی شما در حال حاضر در دسترس نمی باشد.ممکن است توسط مدیر سیستم موقتا غیرفعال یا حذف شده باشد
                    </p>
                  </div>
                </div>
              </section>
    }
    showLoading() {
      this.lockScreen();
      return null;
    }
    renderNoAccess(){
      return (
        <div className="alert alert-danger alert-dismissible">
          <h4><i className="icon fa fa-ban"></i> عدم دسترسی</h4>
          <b>شما مجوز دسترسی و مشاهده اطلاعات بخش درخواستی را ندارید.لطفا با ادمین سیستم هماهنگ نمایید.</b>
        </div>
      );
    }
    renderNoLogin() {
      return (
        <div className="alert alert-danger alert-dismissible">
          <h4><i className="icon fa fa-ban"></i> عدم دسترسی</h4>
          <b>نشست شما با پایان رسیده است.لطفا مجدد وارد حساب کاربری خود شوید</b>
        </div>
      )
    }
    setSort(t, field) {
      let find = 0;
      if (this.state.sort == field) {
        find = 1;
        if (this.state.sort_type == "desc")
          this.state.sort_type = "asc";
        else
          this.state.sort_type = "desc";
      }
      if (find == 0) {
        this.state.sort = field.toString();
        this.state.sort_type = "desc";
        //this.setState({ sort: field.toString() });
        //this.setState({ sort_type: "desc" });
      }
      this.refresh();
    }
    getFormatedDateForDatePicker(dt,defaultIsNull=null){
      if (dt === undefined) if(defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
      if (dt === null) if(defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
      if (dt === "") if(defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
      if ((typeof dt) === "object"){
        return dt;
      }
      if ((typeof dt) === "string")
      {
        dt = this.g2j(dt,3);
        return momentJalaali(dt,'jYYYY-jM-jD');
      }
      else{
        return momentJalaali(dt,'jYYYY-jM-jD');
      }
    }
    getSortString() {
      if (this.state.sort != "")
        return this.state.sort + " " + this.state.sort_type;
      else
        return "";
    }
    getSortArrow(field) {
      for (var i = 0; i < this.state.sort.length; i++) {
        if (this.state.sort[i][0] == field) {
          if (this.state.sort[i][1] == "desc")
            return "fa fa-caret-down";
          if (this.state.sort[i][1] == "asc")
            return "fa fa-caret-up";
        }
      }
    }
    renderList(records, fields, keys) {
      return (
        records.map((hit, index) =>
          <div key={hit.id}>
            <div className={index % 2 == 0 ? "row tb-row" : "row tb-row tb-row-alt"}>
              {fields.map(field =>
                <div className={"col-xs-" + field[2] + " "+field[4]}>
                  {field[3].includes('url') ? (hit[field[0]] == '' || hit[field[0]] === null || hit[field[0]] === undefined) ? null : <a href={hit[field[0]]} target="_blank"><i className="fa fa-link"></i></a> : null}
                  
                  {field[3].includes('string') ?
                    field[3].includes('edit') ? 
                      this.state.on_edit!=null?
                        keys.map(key =>
                          this.getEditLink(hit[key[0]],hit[field[0]])
                        )
                      :
                        hit[field[0]] 
                    :
                      hit[field[0]] 
                  : null}

                  {field[3].includes('fk') ? this.fkParse(field[0],hit) : null}
                  {field[3].includes('CiviliCardNumber') ? this.calcParse("CiviliCardNumber",hit) : null}
                  {field[3].includes('civilicardCredit') ? this.calcParse("civilicardCredit",hit) : null}     
                  {field[3].includes('AuthorAff') ? this.calcParse("AuthorAff",hit) : null}                 
                  {field[3].includes('removeAction') ? this.calcParse("removeAction",hit) : null}
                  {field[3].includes('ForcePersonName') ? this.calcParse("ForcePersonName",hit) : null}
                  {field[3].includes('ForceWriterName') ? this.calcParse("ForceWriterName",hit) : null}
                  {field[3].includes('ForceCommentText') ? this.calcParse("ForceCommentText",hit) : null}
                  {field[3].includes('ForceCommentRequestText') ? this.calcParse("ForceCommentRequestText",hit) : null}
                  {field[3].includes('ForceRequestMaker') ? this.calcParse("ForceRequestMaker",hit) : null}
                  {field[3].includes('indexProgress') ? this.calcParse("indexProgress",hit) : null}
                  {field[3].includes('indexCaption') ? this.calcParse("indexCaption",hit) : null}
                  {field[3].includes('ForceOnlineRecordMaker') ? this.calcParse("ForceOnlineRecordMaker",hit) : null}
                  {field[3].includes('AuthorDoc') ? this.calcParse("AuthorDoc",hit) : null}
                  {field[3].includes('DocView') ? this.calcParse("DocView",hit) : null}           
                  {field[3].includes('commentActions') ? this.calcParse("commentActions",hit) : null}
                  {field[3].includes('RealPersonEdit') ? this.calcParse("RealPersonEdit",hit) : null}
                  {field[3].includes('LegaPersonEdit') ? this.calcParse("LegaPersonEdit",hit) : null}
                  {field[3].includes('StaffEdit') ? this.calcParse("StaffEdit",hit) : null}
                  {field[3].includes('CashPerson') ? this.calcParse("CashPerson",hit) : null}
                  {field[3].includes('RequestModeCaption') ? this.calcParse("RequestModeCaption",hit) : null}
                  {field[3].includes('RequestEdit') ? this.calcParse("RequestEdit",hit) : null}
                  {field[3].includes('number') ? this.money(hit[field[0]]) : null}
                  {field[3].includes('date') ? this.g2j(hit[field[0]],3) : null}
                  {field[3].includes('enum') ? this.enumString(hit[field[0]], field[0]) : null}
                  {field[3].includes('bool') ? this.toBool(hit[field[0]])?<i className="fa fa-check text-green"></i>:<i className="fa fa-check text-gray"></i> : null}
                </div>
              )}  
            </div>
          </div>
        )
      )
    }
    createTableHeader(captions, headerId = "listHeader", params = null) {
      return (
        <div className="row header" id={headerId}>
          {captions.map(item =>
            <div className={"hand col-xs-" + item[2] + " "+item[4]} onClick={(e) => { this.setSort(e, item[0]) }}><i className={this.getSortArrow(item[0])}></i>{item[1]}</div>
          )}
          <div className="col-xs-1 text-left"><i className="fa"></i></div>
        </div>
      )
    }
    getSearchBar(params) {
      return (
        <div className="box box-info">
          <div className="box-body searchBar">
            <div className="col-md-7 col-sm-12 col-xs-12">
              <div className="input-group">
                <input onChange={e => this.setSearchInput(e)} type="text" className="form-control" placeholder="نام / ایمیل / شماره تماس" />
              </div>
            </div>
            <div className="col-md-2 col-sm-12 col-xs-12">
              تعداد در صفحه
                <select className="form-control itemPerPage" onChange={(e) => { this.changeItemPerPage(e) }}>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="60">60</option>
                <option value="80">80</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className="col-md-3 col-sm-12 col-xs-12">
              <span className="recordCount">تعداد نتایج یافت شده: {this.state.data.record_count}</span>
            </div>
          </div>
        </div>
      )
    }
    setSearchInputsValues(t, field, fieldType) {
    }
    setSearchValues(field, value) {
      this.setFilterParamsValue(field,value);
    }
    setSelectedValues(id) {
      var temp = [];
      var find = false;
      for (var i = 0; i < this.state.selected_values.length; i++) {
        if (this.state.selected_values[i] != id)
          temp.push(this.state.selected_values[i])
        else
          find = true;
      }
      if (find)
        this.state.selected_values = temp;
      else
        this.state.selected_values.push(id);
    }
    getPageLink(pageNo) {
      let currentPage = this.getFilterParamsValue("pgn");

      this.setFilterParamsValue("pgn",pageNo)
      let url = this.state.list_url.replace("/api/organ/","/");
      let filter = this.getBaseFilter(true);
      if (filter !== '')
        url += filter + "/";
      
      this.setFilterParamsValue("pgn",currentPage)
      return url;
    }
    createPaging = () => {
      let record_count = this.state.data.record_count;
      let total_page = Math.ceil(record_count / this.getFilterParamsValue("cnt") );
      if (total_page <=1 ) return null;
      let pages = [];
      let page = this.getFilterParamsValue("pgn");
      let start_page = Math.max(1, page - 5);
      let end_page = Math.min(total_page, page + 6);
  
      if (end_page > total_page)
        end_page = total_page;
      if (start_page==end_page && start_page==1)
      {
  
      }
      else{
        for (let i = start_page; i <= end_page; i++) {
          pages.push(<li className={i === page ? "active" : ""}><Link to={this.getPageLink(i)}>{i}</Link></li>)
        }
      }
      return <div className="row">
        <ul className="pagination pagination-sm">
          {pages}
        </ul>
        <select className="form-control w180px" onChange={e=>{this.setFilterParamsValue("cnt",e.target.value);this.refresh()}} defaultValue={this.getFilterParamsValue("cnt")}>
          <option value="12">12 مورد در هر صفحه</option>
          <option value="24">24 مورد در هر صفحه</option>
          <option value="48">48 مورد در هر صفحه</option>
          <option value="72">72 مورد در هر صفحه</option>
        </select>
      </div>
    }
    setSearchInput(t) {
      this.setState({ search_term: t.target.value });
      this.refresh();
    }
    changeItemPerPage(t) {
      this.setState({ item_per_page: parseInt(t.target.value) });
      this.refresh();
    }
    fkParse(field,records)
    {
      var model=field.split(".")[0];
      var prop=field.split(".")[1];
      if (records[model]==null || records[model]==undefined) return "";
  
      //بر اساس عنوان رابطه و کلید اصلی مودال مربوطه را نمایش میدهیم
      if (model=='Affiliation') return <a className="hand" onClick={e=>this.showLegalPerson(records[model]['aff_id'])}>{records[model][prop]}</a>
      if (model=='Association') return <a className="hand" onClick={e=>this.showLegalPerson(records[model]['AssoId'])}>{records[model][prop]}</a>
      
      return records[model][prop];
    }
    //محتوای تول تیپ اشخاص حقیقی رو میسازه
    getRealPersonTip(Person,Id){
      if (Person === null) return null;
      return (
        <ReactTooltip id={Id} effect='solid' delayHide={500} delayShow={500} delayUpdate={500} >
          <div>
            {Person.pic !== undefined ?
              <p><img src={this.toImageUrl(Person,"real_person")} style={{"width":"35px","height":"35px","borderRadius":"100%"}} /></p>
            :null}
            {Person.credit !== undefined ?
              <p style={{"lineHeight":"35px"}}>اعتبار: {Person.credit}</p>
            :null}
            {Person.email !== undefined ?
              <p>{Person.email_activate === 1 ? <i className="fa fa-check text-green"></i> : <i className="fa fa-close text-red"></i>} {Person.email === "" || Person.email === null ? "فاقد آدرس ایمیل" : Person.email}</p>
            :null}
            {Person.mobile !== undefined ?
              <p>{Person.mobile_activate === 1 ? <i className="fa fa-check text-green"></i> : <i className="fa fa-close text-red"></i>} {Person.mobile === "" || Person.mobile === null ? "فاقد شماره موبایل" : Person.mobile}</p>
            :null}
            {Person.display !== undefined ?
              <p>رزومه: {Person.display === 1 ? "فعال" : "غیرفعال"}</p>
            :null}
            {Person.affiliation != undefined ?
              Person.affiliation !== "" && Person.affiliation !== null ?
              <p>سمت: {Person.affiliation}</p>
              :null
            :null}
            {Person.state != undefined ?
              Person.state === 0?
              <p>تبت اولیه اطلاعات توسط مدیر</p>
              :Person.state === 1?
              <p>تبت نام شده</p>
              :Person.state === 2?
              <p>ثبت نام شده با اطلاعات موجود</p>
              :null
            :null}
          </div>
        </ReactTooltip>
      )
    }
    //محتوای تول تیپ اشخاص حقیقی رو میسازه
    getRequestTip(Request,Id){
      if (Request === null) return null;
      return (
        <ReactTooltip id={Id} effect='solid' delayHide={500} delayShow={500} delayUpdate={500} >
          <div>
            {Request.AddDate !== undefined ?
              <p>تاریخ ثبت: {this.g2j(Request.AddDate,6)}</p>
            :null}
            {Request.mode !== undefined ?
              <p>نحوه دریافت: {this.enumString(Request.mode,"mode")}</p>
            :null}
            {Request.IP !== undefined ?
              <p>آی پی: {Request.IP}</p>
            :null}
          </div>
        </ReactTooltip>
      )
    }
    //اختلاف زمان ۲ تاریخ
    getDateDeff(from,to){
      if (from === null || to === null) return "منتظر";
      let defSeconds = Math.round((new Date(to).getTime() - new Date(from).getTime()) / 1000);

      if (defSeconds > 86400)
        return Math.round(defSeconds/86400) + " روز";
      else
        if(defSeconds<60)
          return "لحظاتی پیش"
        else
          if(defSeconds<3600)
            return Math.round(defSeconds/60) + " دقیقه";
          else
            return Math.round(defSeconds/3600) + " ساعت";
    }
    //مخصوص لیست نمایه سازی
    getTypesFromId(id){
      id = parseInt(id);
      let typest = null;
      this.state.data.typest.forEach(_t => {
        if (_t.id === id) typest = _t;
      });
      return typest !== null ? typest.name : "";
    }
    calcParse(field,records)
    {
      //حذف رکورد با ای دی id
      if (field==="removeAction")
      {
          return <a onClick={e=>this.remove(records.id)} ><i title="حذف" className="fa fa-trash text-red"></i></a>
      }
      //نویسنده نظر
      if (field==="ForceWriterName")
      {
        if (records.RealPerson !==undefined && records.RealPerson!==null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.RealPerson,'ForceWriterName'+uuid)
          ,
            <Link data-tip data-for={'ForceWriterName'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + ' ' + records.RealPerson.lname}</Link>
          ]
        }
        else
          return records.writer_name;
      }
      //متن نظر
      if (field==="ForceCommentText")
      {
          let t = []
          t.push(records.text);
          t.push(<br/>);
          for (var i=records.score;i<5;i++)
            t.push(<i className="fa fa-star text-white"></i>);
          for (var i=0;i<records.score;i++)
            t.push(<i className="fa fa-star text-yellow"></i>);
          t.push(<small style={{"float":"left"}}>{this.g2j(records.date,6)}</small>);
          return t;
      }
      //شماره کارت اعتباری
      if (field==="CiviliCardNumber")
      {
          return records.crd1 + " - " + records.crd2 + " - " + records.crd3 + " - " + records.crd4;
      }
      if (field==="civilicardCredit")
      {
          if (records.price == 0 || records.price == null)
            return this.money(records.credit) + " اعتبار";
          else
            return this.money(records.price) + " ریال";
      }   
      if (field==="AuthorAff")
      {
          if (records.role == '' || records.role == null)
            return records.aff;
          else
            return records.aff + " - " + records.role;
      }            
      
      //بخش درخواست نظر
      if (field==="ForceCommentRequestText")
      {
        if (records.Request !== undefined && records.Request !== null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRequestTip(records.Request,'ForceCommentRequestText'+uuid)
          ,
            <Link data-tip data-for={'ForceCommentRequestText'+uuid} to={"/requests/edit/" + records.Request.id +"/"}>{records.Request.id}</Link>
          ]
        }
        else
          return <Link to={"/requests/edit/" + records.request_id +"/"}>{records.request_id}</Link>
      }
      //به خاطر اینکه اسم نویسنده تیکت از جای مختلف ارسال میشه برای همین به این شکل هندلش کردم
      if (field==="ForcePersonName")
      {
        if (records.Person!==undefined && records.Person!==null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.Person,'ForcePersonName'+uuid)
          ,
            <Link data-tip data-for={'ForcePersonName'+uuid} to={"/realpersons/edit/" + records.Person.person_id +"/"}><i title="کاربر عضو" className="fa fa-star text-yellow"></i> {records.Person.fname + ' ' + records.Person.lname}</Link>
          ]
        }
        else
          return records.name;
      }
      //در لیست دریافتها نمایش نام گیرنده بر حسب شریطش خواهد بود
      if (field==="ForceRequestMaker")
      {
        //خود کاربر
        if (records.mode===1 && records.RealPerson !== null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.RealPerson,'ForceRequestMaker'+uuid)
          ,
            <Link data-tip data-for={'ForceRequestMaker'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
          ]
        }
        //تکی
        if (records.mode===4)
          return records.UserEMail;
        //موبایلی
        if (records.mode===2 && records.RealPerson !== null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.RealPerson,'ForceRequestMaker'+uuid)
          ,
            <Link data-tip data-for={'ForceRequestMaker'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
          ]
        }
        //ایمیل سازمانی
        if (records.mode===7 && records.RealPerson !== null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.RealPerson,'ForceRequestMaker'+uuid)
          ,
            <Link data-tip data-for={'ForceRequestMaker'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
          ]
        }
        //آی پی
        if (records.mode===3 || records.mode===6 || records.mode===5)
          return records.UserEMail;
        
        return "";
      }
      //نمایش عنوان جدول نمایه سازی
      if (field==="indexCaption")
      {
        let step = '';
        if(records.step === 101) step='ready';
        if(records.step === 102) step='type';
        if(records.step === 103) step='excell';
        if(records.step === 104) step='excelldone';
        if(records.step === 105) step='topublish';

        return <div>
                <Link to={"/index/" + step + "/edit/" + records.person_id + "/"}>{records.name}</Link>
                <br/>
                کد <Link to={"/l/" + records.person_id + "/"}>{records.link_cell}</Link>
                &nbsp;|&nbsp;
                برگزاری : {this.g2j(records.start)}
                &nbsp;|&nbsp;
                درج : {this.g2j(records.add_date)}
               </div>
      }
      //نمایش پیشرفت نمایه سازی در جدول نمایه سازی ها
      if (field==="indexProgress")
      {
        var PaperRecievType = null;
        var CDreceivedDate = null;

        var index1Date = null;
        var index1Count = null;

        var index2Date = null;
        var indexTypistId = null;

        var index3Date = null;
        var index3Count = null;

        var index4Date = null;
        var index4Count = null;

        var index5Date = null;
        
        var index6Date = null;

        records.Fields.forEach(_fi => {
          if (_fi.field === 'PaperRecievType') PaperRecievType = _fi.value;
          if (_fi.field === 'CDreceivedDate') CDreceivedDate = _fi.value;
          if (_fi.field === 'index1Date') index1Date = _fi.value;
          if (_fi.field === 'index1Count') index1Count = _fi.value;
          if (_fi.field === 'index2Date') index2Date = _fi.value;
          if (_fi.field === 'indexTypistId') indexTypistId = _fi.value;
          if (_fi.field === 'index3Date') index3Date = _fi.value;
          if (_fi.field === 'index3Count') index3Count = _fi.value;
          if (_fi.field === 'index4Date') index4Date = _fi.value;
          if (_fi.field === 'index4Count') index4Count = _fi.value;
          if (_fi.field === 'index5Date') index5Date = _fi.value;
          if (_fi.field === 'index6Date') index6Date = _fi.value;
        });

        let steps = [];
        let done = ""

        if (records.step > 100) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _1 " + done}>
          <time>{this.getDateDeff(records.add_date , CDreceivedDate)}</time>
          <b>دریافت مقالات ({this.enumString(PaperRecievType,"PaperRecievType")})</b><br/>{this.g2j(CDreceivedDate,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step > 101) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _2 " + done}>          
          <time>{this.getDateDeff(CDreceivedDate , index1Date)}</time>
          <b>آماده سازی جداول {index1Count !== null ? "(" + index1Count + " مقاله)": ""}</b><br/>{this.g2j(index1Date,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step > 102) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _3 " + done}>
          <time>{this.getDateDeff(index1Date , index2Date)}</time>
          <b>تحویل به {indexTypistId !== null ? "(" + this.getTypesFromId(indexTypistId) + ")": ""}</b><br/>{this.g2j(index2Date,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step > 103) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _4 " + done}>
          <time>{this.getDateDeff(index2Date , index3Date)}</time>
          <b>دریافت اکسل {index3Count !== null ? "(" + index3Count + " مقاله)": ""}</b><br/>{this.g2j(index3Date,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step > 104) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _5 " + done}>
          <time>{this.getDateDeff(index3Date , index4Date)}</time>
          <b>آماده سازی اکسل {index4Count !== null ? "(" + index4Count + " مقاله)": ""}</b><br/>{this.g2j(index4Date,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step > 105) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _6 " + done}>
          <time>{this.getDateDeff(index4Date , index5Date)}</time>
          <b>تحویل نهایی</b><br/>{this.g2j(index5Date,2)}</span>);
        steps.push(<i className="fa fa-caret-left"></i>);

        if (records.step == 106) done = "done"; else done = "";
        steps.push(<span className={"indexSteps _7 " + done}>
          <time>{this.getDateDeff(index5Date , index6Date)}</time>
          <b>پابلیش</b><br/>{this.g2j(index6Date,2)}</span>);

        return steps;
      }
      //در لیست رکوردهای آنلاین نام طرف حساب بر حسب شریطش خواهد بود
      if (field==="ForceOnlineRecordMaker")
      {
        //خود کاربر
        if (records.RealPerson !== null)
        {
          let uuid=this.uuidv4();
          return [
            this.getRealPersonTip(records.RealPerson,'ForceOnlineRecordMaker'+uuid)
          ,
            <Link data-tip data-for={'ForceOnlineRecordMaker'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
          ]
        }
        else
          return records.Email;
        
        return "";
      }
      //مشاهده سند
      if (field === "DocView")
      {
        if (records.RqstdFileID !== undefined)
          return <a target='_blank' href={'/doc/'+records.RqstdFileID+'/'}>{records.RqstdFileID}</a>
        if (records.document_id !== undefined)
          return <a target='_blank' href={'/doc/'+records.document_id+'/'}>{records.document_id}</a>
        return "";        
      }
      if (field === "AuthorDoc")
      {
        if (records.Document !== undefined && records.Document !== null)
          return <a target='_blank' href={'/doc/'+records.Document.id+'/'}>{records.Document.title}</a>
        return "";        
      }
      
      //عملیات مربوط به نظرات
      if (field === "commentActions")
      {
        if (records.status === 0)
          return <p>
                  <button className="btn mr-l-5" title="تا یید نظر" onClick={e => this.changeCommentStatus(records.id,1)}><i className="fa fa-check text-green"></i></button>
                  <button className="btn" title="رد نظر" onClick={e => this.changeCommentStatus(records.id,2)}><i className="fa fa-trash text-red"></i></button>
                 </p>
        if (records.status === 1)
          return <p className="text-green">تایید در {this.g2j(records.check_date)}</p>
        if (records.check_date === 1)
        return <p className="text-red">رد مورخ {this.g2j(records.check_date)}</p>
        return "";        
      }      
      //شخص حقیقی
      if (field === 'RealPersonEdit')
      {
        let uuid=this.uuidv4();
        return [
          this.getRealPersonTip(records.RealPerson,'ForceRequestMaker'+uuid)
        ,
          <Link data-tip data-for={'ForceRequestMaker'+uuid} to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
        ]
      }
      //کارمند
      if (field === 'StaffEdit')
      {
        if (records.Staff === null) return "";
        return <Link to={"/staffs/edit/" + records.Staff.id +"/"}>{records.Staff.name}</Link>
      }
      //درخواست
      if (field === 'RequestEdit')
      {
        if (records.Request !== undefined)
          if (records.Request !== null)
            return <Link to={"/requests/edit/" + records.Request.id +"/"}>{records.Request.id}</Link>
        if (records.request_id !== undefined)
          return <Link to={"/requests/edit/" + records.request_id +"/"}>{records.request_id}</Link>
        return "";
      }      
      //شخص حقوقی
      if (field === 'LegaPersonEdit')
      {
        if (records.LegalPerson === null) return "";
        return <Link to={"/legalpersons/edit/" + records.LegalPerson.person_id +"/"}>{records.LegalPerson.name}</Link>
      }
      
      //طرف حساب واریزی
      if (field==="CashPerson")
      {
        if (records.RealPerson !== null)
          return <Link to={"/realpersons/edit/" + records.RealPerson.person_id +"/"}>{records.RealPerson.fname + " " + records.RealPerson.lname}</Link>
        if (records.LegalPersonAccount !== null)
          if (records.LegalPersonAccount.LegalPerson !== null)
            return <Link to={"/legalaccounts/edit/" + records.LegalPersonAccount.id +"/"}>{records.LegalPersonAccount.LegalPerson.name}</Link>
          else
            return <Link to={"/legalaccounts/edit/" + records.LegalPersonAccount.id +"/"}>مرکز تعیین نشده</Link>

        return "";
      }
      //نحوه دریافت مقالات
      if(field === 'RequestModeCaption'){
        if (records.mode === 2 || records.mode === 3 || records.mode === 5 || records.mode === 7)
        {
          if (records.LegalPersonAccount !== null)
          {
            if (records.LegalPersonAccount.LegalPerson !== null)
              return [this.enumString(records.mode,"mode") 
                      ,
                      "[" 
                      , 
                      <Link to={"/legalaccounts/edit/" + records.LegalPersonAccount.id +"/"}>{records.LegalPersonAccount.LegalPerson.name}</Link>
                      ,
                      "]"
                    ]
            else
              return [this.enumString(records.mode,"mode") 
                      ,
                      "[" 
                      , 
                      <Link to={"/legalaccounts/edit/" + records.LegalPersonAccount.id +"/"}>مرکز تعیین نشده</Link>
                      ,
                      "]"
                    ]
          }
          else
          return [this.enumString(records.mode,"mode") 
                  ,
                  "[" 
                  , 
                  "مرکز نامشخص"
                  ,
                  "]"
                ]
        }
        else
        {
          if (records.mode === 6)
          {
            if (records.Staff !== null)
              return [this.enumString(records.mode,"mode") 
                      ,
                      "[" 
                      , 
                      <Link to={"/staffs/edit/" + records.Staff.id +"/"}>{records.Staff.name}</Link>
                      ,
                      "]"
                    ]
            else
              return "اپراتور با شناسه " + records.staff_id;
          }
          else
            return this.enumString(records.mode,"mode")
        }
      }
      return null;
    }
    //format
    //0 => ۲۰ آذر ۱۳۹۸
    //1 => آذر
    //2 => چهارشنبه، ۷ اسفند، ۱۳۹۸
    //3=>1398/12/25
    //4 => 1398
    //5 => 25
    //6 => چهارشنبه، ۷ اسفند، ۱۳۹۸ ۱۲:۲۰:۳۰
    g2j(pDate,format=0){
      try{
        if (pDate === null || pDate === undefined) return "";
        //وقتی سمت سرور رندر میکنیم این مقدار به صورت یک آبجکت تاریخ هست که بایستی تبدیل کنیم به رشته تاریخی
        if (typeof(pDate) === "string")
        {
          pDate = new Date(pDate)
        }
        
        var gy='';
        var gm='';
        var gd='';

        gy=parseInt(pDate.getFullYear());
        gm=parseInt(pDate.getMonth()+1);
        gd=parseInt(pDate.getDate());

        if (gy==='')return '';
        var g_d_m,jy,jm,jd,gy2,days;
        g_d_m=[0,31,59,90,120,151,181,212,243,273,304,334];
        if(gy > 1600){
        jy=979;
        gy-=1600;
        }else{
        jy=0;
        gy-=621;
        }
        gy2=(gm > 2)?(gy+1):gy;
        days=(365*gy) +(parseInt((gy2+3)/4)) -(parseInt((gy2+99)/100)) +(parseInt((gy2+399)/400)) -80 +gd +g_d_m[gm-1];
        jy+=33*(parseInt(days/12053)); 
        days%=12053;
        jy+=4*(parseInt(days/1461));
        days%=1461;
        if(days > 365){
        jy+=parseInt((days-1)/365);
        days=(days-1)%365;
        }
        jm=(days < 186)?1+parseInt(days/31):7+parseInt((days-186)/30);
        jd=1+((days < 186)?(days%31):((days-186)%30));
        if (format === 0)
        {
          if (jm===1)
            return jd+" فروردین "+jy;
          if (jm===2)
            return jd+" اردیبهشت "+jy;
          if (jm===3)
            return jd+" خرداد "+jy;
          if (jm===4)
            return jd+" تیر "+jy;
          if (jm===5)
            return jd+" مرداد "+jy;
          if (jm===6)
            return jd+" شهریور "+jy;
          if (jm===7)
            return jd+" مهر "+jy;
          if (jm===8)
            return jd+" آبان "+jy;
          if (jm===9)
            return jd+" آذر "+jy;
          if (jm===10)
            return jd+" دی "+jy;
          if (jm===11)
            return jd+" بهمن "+jy;
          if (jm===12)
            return jd+" اسفند "+jy;
        }
        if (format === 1)
        {
          if (jm===1)
            return "فروردین";
          if (jm===2)
            return "اردیبهشت";
          if (jm===3)
            return "خرداد";
          if (jm===4)
            return "تیر";
          if (jm===5)
            return "مرداد";
          if (jm===6)
            return "شهریور";
          if (jm===7)
            return "مهر";
          if (jm===8)
            return "آبان";
          if (jm===9)
            return "آذر";
          if (jm===10)
            return "دی";
          if (jm===11)
            return "بهمن";
          if (jm===12)
            return "اسفند";
        }
        if (format === 2)
        {
          let dayOfWeekNum = pDate.getDay();
          let dayName = '';
          if (dayOfWeekNum === 0) dayName = 'یکشنبه';
          if (dayOfWeekNum === 1) dayName = 'دوشنبه';
          if (dayOfWeekNum === 2) dayName = 'سه شنبه';
          if (dayOfWeekNum === 3) dayName = 'چهارشنبه';
          if (dayOfWeekNum === 4) dayName = 'پنجشنبه';
          if (dayOfWeekNum === 5) dayName = 'جمعه';
          if (dayOfWeekNum === 6) dayName = 'شنبه';
          if (jm===1)
            return dayName + '، ' + jd+" فروردین، "+jy;
          if (jm===2)
            return dayName + '، ' + jd+" اردیبهشت، "+jy;
          if (jm===3)
            return dayName + '، ' + jd+" خرداد، "+jy;
          if (jm===4)
            return dayName + '، ' + jd+" تیر، "+jy;
          if (jm===5)
            return dayName + '، ' + jd+" مرداد، "+jy;
          if (jm===6)
            return dayName + '، ' + jd+" شهریور، "+jy;
          if (jm===7)
            return dayName + '، ' + jd+" مهر، "+jy;
          if (jm===8)
            return dayName + '، ' + jd+" آبان، "+jy;
          if (jm===9)
            return dayName + '، ' + jd+" آذر، "+jy;
          if (jm===10)
            return dayName + '، ' + jd+" دی، "+jy;
          if (jm===11)
            return dayName + '، ' + jd+" بهمن، "+jy;
          if (jm===12)
            return dayName + '، ' + jd+" اسفند، "+jy;
        }
        if (format === 3)
        {
          if (jd<10) jd = "0" + jd;
          if (jm<10) jm = "0" + jm;
          return jy+"/"+jm+"/"+jd;
        }
        if (format === 4)
        {
          return jy;
        }
        if (format === 5)
        {
          return jd;
        }
        if (format === 6)
        {
          let dayOfWeekNum = pDate.getDay();
          let dayName = '';
          if (dayOfWeekNum === 0) dayName = 'یکشنبه';
          if (dayOfWeekNum === 1) dayName = 'دوشنبه';
          if (dayOfWeekNum === 2) dayName = 'سه شنبه';
          if (dayOfWeekNum === 3) dayName = 'چهارشنبه';
          if (dayOfWeekNum === 4) dayName = 'پنجشنبه';
          if (dayOfWeekNum === 5) dayName = 'جمعه';
          if (dayOfWeekNum === 6) dayName = 'شنبه';
          var time = pDate.getHours() + ":" + pDate.getMinutes() + ":" + pDate.getSeconds();

          if (jm===1)
            return dayName + '، ' + jd+" فروردین، "+jy + " " + time;
          if (jm===2)
            return dayName + '، ' + jd+" اردیبهشت، "+jy + " " + time;
          if (jm===3)
            return dayName + '، ' + jd+" خرداد، "+jy + " " + time;
          if (jm===4)
            return dayName + '، ' + jd+" تیر، "+jy + " " + time;
          if (jm===5)
            return dayName + '، ' + jd+" مرداد، "+jy + " " + time;
          if (jm===6)
            return dayName + '، ' + jd+" شهریور، "+jy + " " + time;
          if (jm===7)
            return dayName + '، ' + jd+" مهر، "+jy + " " + time;
          if (jm===8)
            return dayName + '، ' + jd+" آبان، "+jy + " " + time;
          if (jm===9)
            return dayName + '، ' + jd+" آذر، "+jy + " " + time;
          if (jm===10)
            return dayName + '، ' + jd+" دی، "+jy + " " + time;
          if (jm===11)
            return dayName + '، ' + jd+" بهمن، "+jy + " " + time;
          if (jm===12)
            return dayName + '، ' + jd+" اسفند، "+jy + " " + time;
        }
        return jy+"-"+jm+"-"+jd;
      }
      catch(err){return ""}
    }
    //format
    //0 => 20 aug 2020
    //1 => aug
    //2 => چهارشنبه، ۷ اسفند، ۱۳۹۸
    //3=>2020/12/25
    //4 => 2021
    //5 => 25
    //6 => چهارشنبه، ۷ اسفند، ۱۳۹۸ ۱۲:۲۰:۳۰
    //7 => 25 aug
    gFormat(pDate,format=0){
      try{
        if (pDate === null || pDate === undefined || pDate === "") return "";
       
        if (typeof(pDate) === "string")
        {
          pDate = new Date(pDate)
        }

        var jy=parseInt(pDate.getFullYear());
        var jm=parseInt(pDate.getMonth()+1);
        var jd=parseInt(pDate.getDate());

        if (format === 0)
        {
          return jd + " " + this.enumString(jm,'miladi_month') +  " "  + jy;
        }
        
        if (format === 1)
        {
          return this.enumString(jm,'miladi_month');
        }
        if (format === 4)
        {
          return jy;
        }
        if (format === 5)
        {
          return jd;
        }
        return jy+"-"+jm+"-"+jd;
      }
      catch(err){return ""}
    }
    j2g(jy,jm,jd){
      var sal_a,gy,gm,gd,days,v;
      if(jy > 979){
      gy=1600;
      jy-=979;
      }else{
      gy=621;
      }
      days=(365*jy) +((parseInt(jy/33))*8) +(parseInt(((jy%33)+3)/4)) +78 +jd +((jm<7)?(jm-1)*31:((jm-7)*30)+186);
      gy+=400*(parseInt(days/146097));
      days%=146097;
      if(days > 36524){
      gy+=100*(parseInt(--days/36524));
      days%=36524;
      if(days >= 365)days++;
      }
      gy+=4*(parseInt(days/1461));
      days%=1461;
      if(days > 365){
      gy+=parseInt((days-1)/365);
      days=(days-1)%365;
      }
      gd=days+1;
      sal_a=[0,31,((gy%4===0 && gy%100!==0) || (gy%400===0))?29:28,31,30,31,30,31,31,30,31,30,31];
      for(gm=0;gm<13;gm++){
      v=sal_a[gm];
      if(gd <= v)break;
      gd-=v;
      }
      return jy+"-"+jm+"-"+jd;
    }
    lockScreen() {
      $('#mainLoadingBox').show();
    }
    unLockScreen() {
      $('#mainLoadingBox').hide();
    }
    toBool(value)
    {
      value=this.englishChar(value);
      if (value=='1') return true;
      if (value=='0') return false;
      if (value==1) return true;
      if (value==0) return false;
      return value;
    }
    enumString(num, field) {
      field = field.toLowerCase();

      if(field=="card_status")
      {
        num = parseInt(num);
        if (num === 1) return <span className='text-red'>استفاده شده</span>;
        if (num === 0) return <span className='text-green'>معتبر</span>;
      }
      if(field=="card_type")
      {
        num = parseInt(num);
        if (num === 1) return "فروش";
        if (num === 2) return "هدیه";
      }
      //انواع کارهای crm
      if(field=="task_type")
      {
        num = parseInt(num);
        if (num === 1) return [<i class="fal fa-phone-square"></i>," تماس تلفنی"];
        if (num === 2) return [<i class="fal fa-mailbox"></i>," پست"];
        if (num === 3) return [<i class="far fa-fax"></i>," فکس"];
        if (num === 4) return [<i class="fas fa-laptop-code"></i>," پیام سیستمی"];
        if (num === 5) return [<i class="far fa-tasks"></i>," پیگیری امور"];
      } 
      //وضعیت کارهای crm
      if(field=="crm_task_status")
      {
        num = parseInt(num);
        if (num === 1) return "باز";
        if (num === 2) return "بسته شده";
        if (num === 3) return "ارجاع شده";
      } 
      //انواع روش های خرید مقاله
      if(field=="mode")
      {
        num = parseInt(num);
        if (num === 1) return "کاربر عضو";
        if (num === 2) return "موبایلی";
        if (num === 3) return "آی پی";
        if (num === 4) return "خرید تکی";
        if (num === 5) return "مستقیم";
        if (num === 6) return "اپراتور";
        if (num === 7) return "ایمیل سازمانی";
        if (num === 8) return "وبسرویس";
      } 
      //نحوه دریافت مقالات کنفرانس
      if(field=="paperrecievtype")
      {
        num = parseInt(num);
        if (num === 1) return "سی دی";
        if (num === 2) return "ایمیل";
        if (num === 3) return "تلگرام";
        if (num === 4) return "فلش";
        if (num === 5) return "آپلود روی سایت";
      } 
      //انواع اسناد
      if(field=="document_type")
      {
        if (num == 1) return "مقاله";
        if (num == 3) return "طرح تحقیقاتی";
      }   
      //انواع مقالات
      if(field=="document_sub_type")
      {
        if (num == 1) return "کنفرانسی";
        if (num == 2) return "ژورنالی";
        if (num == 3) return "کتاب";
        if (num == 4) return "طرح پژوهشی";
      }
      //انواع ارایه مقالات
      if(field=="present")
      {
        if (num == 1) return "شفاهی";
        if (num == 2) return "پوستر";
        if (num == 3) return "سی دی";
        if (num == 4) return "کارگاه";
        if (num == 5) return "چاپی";
      }
      //انواع عناوین شخص حقیقی
      if(field=="user_title")
      {
        if (num == 1) return "پروفسور";
        if (num == 2) return "دکتر"
        if (num == 3) return "مهندس";
        if (num == 4) return "سردار";
        if (num == 5) return "حجة الاسلام";
      }
      //انواع نوشته
      if(field=="post_type")
      {
        if (num == 1) return "سیولیکا";
        if (num == 2) return "خبر"
        if (num == 3) return "کنفرانس";
      }
      //انواع اطلاعات رزومه
      if(field=="resumes_type")
      {
        if (num == 1) return "مقاله کنفرانس";
        if (num == 2) return "مقاله ژورنالی";
        if (num == 3) return "تحقیق";
        if (num == 4) return "شغل";
        if (num == 5) return "جایزه";
        if (num == 6) return "کارگاه";
        if (num == 7) return "تمایلات";
        if (num == 8) return "سایر";
        if (num == 9) return "انجمنها";
        if (num == 10) return "مقاله ISI";
        if (num == 11) return "کتاب";
      } 
      //انواع اطلاعات تماس
      if(field=="contact_type")
      {
        if (num == 1) return "تلفن";
        if (num == 2) return "موبایل";
        if (num == 3) return "فکس";
        if (num == 4) return "ایمیل";
        if (num == 5) return "آدرس";
        if (num == 6) return "آدرس لاتین";
        if (num == 7) return "کدپستی";
        if (num == 8) return "صندوق پستی";
        if (num == 9) return "تلگرام";
        if (num == 10) return "اینستاگرام";
        if (num == 11) return "فیسبوک";
        if (num == 12) return "لینکدین";
        if (num == 13) return "گوگل پلاس";
        if (num == 14) return "ریسرچ گیت";
        if (num == 15) return "تویتر";
        if (num == 16) return "وبسایت";
      }  
      //انواع وضعیتهای تیکت
      if(field=="ticket_status")
      {
        if (num == 1) return <i className="text-blue">در انتظار پاسخ</i>;
        if (num == 2) return <i className="text-green">پاسخ داده شده</i>;
        if (num == 3) return <i className="text-yellow">ارجاع شده</i>;
        if (num == 4) return <i className="text-red">بسته شده</i>;
      }
      //انواع موضوعات تیکتها
      if(field === "topic_id")
      {
        if (num === 1) return "مشکل در روند عضویت، ثبت نام و خرید اعتبار";
        if (num === 3) return "مشکل در پرداخت اینترنتی";
        if (num === 2) return "مشکل در دریافت مقالات و مستندات";
        if (num === 4) return "درخواست ویرایش مقالات";
        if (num === 5) return "همکاری با سیویلیکا، پیشنهاد، انتقاد";
        if (num === 6) return "دریافت گواهی نمایه سازی";
        if (num === 7) return "پیگیری نمایه مقالات کنفرانسها و ژورنالها";
        if (num === 8) return "مشکلات مربوط به رزومه";
        if (num === 9) return "رسیدگی به امور مراکز";
      }
      //عناوین پرداختها
      if(field=="paytypefor" || field=='type')
      {
        if (num == 1) return "کتاب";
        if (num == 2) return "افزایش اعتبار";
        if (num == 3) return "ISI";
        if (num == 4) return "مقاله";
        if (num == 5) return "ثبت نام";
        if (num == 6) return "گواهی";
        if (num == 7) return "برگشت";
        if (num == 8) return "کارت هدیه";
        if (num == 9) return "هدیه فعالیت";
        if (num == 10) return "متفرقه";
        if (num == 11) return "کاهش اعتبار";
        if (num == 12) return "فیش";
      }
      //اسامی بانکها
      if(field === "bankname" || field === "gateway_id")
      {
        if (num == 1) return "سامان";
        if (num == 2) return "ملت";
        if (num == 3) return "پارسیان";
        if (num == 4) return "زرین پال";
        if (num == 5) return "صادرات";
      }
      //وضعیت سفارشات
      if(field=="isiorderstatus")
      {
        if (num == 1) return <span className="text-yellow">تامین شده</span>;
        if (num == 2) return <span className="text-blue">در انتظار تامین</span>;
        if (num == 3) return <span className="text-red">کنسل شده</span>;
        if (num == 4) return <span className="text-green">تحویل آنی</span>;
      }
      //وضعیت درخواستها  
      if(field=="requeststatus")
      {
        if (num == 1) return "تحویل داده شد";
        if (num == 2) return "منتظر تامین";
        if (num == 3) return "کنسل شده";
        if (num == 4) return "تامین آنی";
        if (num == 5) return "خطا در تامین";
      }
      //تامین کننده مقالات سفارش
      if(field=="providerid")
      {
        if (num == 1) return "دانش گستر";
        if (num == 2) return "فالینوس";
      }  
      //نوع درخواستها
      if(field=="requesttype")
      {
        if (num == 1) return "کنفرانس داخلی";//C_Paper
        if (num == 2) return "ژورنال داخلی";//J_Paper
        if (num == 3) return "کتاب";//eBook
        if (num == 4) return "مقالات لاتین";//EnPaper
        if (num == 5) return "پروژه";//Project
        if (num == 6) return "گواهی";//Cert
        if (num == 7) return "ISI";
      }
      //نقش کارمندان
      if(field=="role")
      {
        if (num == 1) return "مدیر ارشد";
        if (num == 2) return "اپراتور";
        if (num == 3) return "تایپیست";
      }
      //وضعیتها
      if(field=='status')
      {
        if (num == 1) return "فعال";
        if (num == 0) return "غیرفعال";
      }
      //نوع سازمانی شحص حقوقی
      if(field=='organ_type')
      {
        if (num == 1) return "دولتی";
        if (num == 2) return "خصوصی";
      }
      //نوع دانشگاه ها
      if (field == 'aff_type') {
        if (num == 1) return "دانشگاه دولتی";
        if (num == 2) return "دانشگاه آزاد";
        if (num == 3) return "پژوهشگاه دولتی";
        if (num == 4) return "شرکت";
        if (num == 5) return "موسسه غیرانتفاعی";
        if (num == 6) return "پیام نور";
        if (num == 7) return "علوم پزشکی";
        if (num == 8) return "سازمان تحقیقات کشاورزی";
      }
      //نوع نشریه
      if (field == 'publicationtype') {
        if (num == '0') return "هیچکدام";
        if (num == 'P') return "فقط چاپ";
        if (num == 'B') return "فقط آنلاین";
        if (num == 'E') return "چاپ و آنلاین";
      }
      //سطح نشریه
      if (field == 'journallevel') {
        if (num == 0) return "هیچ کدام";
        if (num == 1) return "ISI";
        if (num == 2) return "علمی-پژوهشی";
        if (num == 3) return "علمی-ترویجی";
      }
      //دوره انتشار نشریه
      if (field == 'frequency') {
        if (num == 0) return "موردی";
        if (num == 1) return "سالانه";
        if (num == 2) return "دوفصلی";
        if (num == 4) return "فصلی";
        if (num == 6) return "دوماهانه";
        if (num == 12) return "ماهانه";
        if (num == 27) return "دوهفتگی";
        if (num == 54) return "هفتگی";
      }
      //زبان نشریه
      if (field == 'language') {
        if (num === null || num === undefined) return "";
        //fa 1
        //en 2
        //ar 3
        //fr 4
        return num.toString().replace("1", "فارسی").replace("2", "انگلیسی").replace("3", "عربی").replace("4", "فرانسوی")
                              .replace("Fa", "فارسی").replace("En", "انگلیسی").replace("Ar", "عربی").replace("Fr", "فرانسوی");
      }
      //انواع نشست
      if (field == 'meetingtype') {
        if (num == 10) return "سخنرانی علمی";
        if (num == 20) return "کارگاه آموزشی";
        if (num == 30) return "دوره آموزشی";
        if (num == 40) return "دفاعیه ارشد";
        if (num == 50) return "دفاعیه دکترا";
        if (num == 60) return "رویداد کارآفرینی";
      }
      //انواع اکشنها لاگ
      if (field == 'log_type') {
        if (num == 1) return <i className='fa fa-plus text-green'></i>;//"افزودن";
        if (num == 2) return <i className='fa fa-pencil text-blue'></i>;//"ویرایش";
        if (num == 3) return <i className='fa fa-trash text-red'></i>;//"حذف";
      }
      //انواع رکوردهای لاگ
      if (field == 'object_type') {
        if (num == 1) return "نوشته";
        if (num == 2) return "مقاله";
        if (num == 3) return "شخص حقیقی";
        if (num == 4) return "شخص حقوقی";
        if (num == 5) return "کارمند";
        if (num == 6) return "درخواست";
        if (num == 7) return "سفارش";
        if (num == 8) return "واریزی";
        if (num == 9) return "تنظیمات";
        if (num == 10) return "رکورد انلاین";
        if (num == 11) return "افراد مهم";
        if (num == 12) return "تیکت";
        if (num == 13) return "گواهی";
        if (num == 14) return "تعاریف";
        if (num == 15) return "نمایه سازی";
        if (num == 16) return "نظرات";
        if (num == 17) return "مقالات بین المللی";
        if (num == 18) return "اطلاعات موقت";
        if (num == 19) return "حساب حقوقی";
        if (num == 20) return "آی پی";
        if (num == 21) return "موضوع";
        if (num == 22) return "کلیدواژه";
      }
      
    }
    money(value) {
      var number = typeof value === "number" ? value.toString() : value;
      var separator = ',';
      if (number === null || number === undefined)
        return "";
      var s = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separator);
      return s;
    }
    farsiChar(value) {
      if (value === undefined)
        return "";
      if (window.calendarType === 1) return value + "";
    
      value += "";
      value = value.replace(/0/g, "۰");
      value = value.replace(/1/g, "۱");
      value = value.replace(/2/g, "۲");
      value = value.replace(/3/g, "۳");
      value = value.replace(/4/g, "۴");
      value = value.replace(/5/g, "۵");
      value = value.replace(/6/g, "۶");
      value = value.replace(/7/g, "۷");
      value = value.replace(/8/g, "۸");
      value = value.replace(/9/g, "۹");
      return value;
    }
    englishChar(value) {
      if (value === undefined)
        return "";
      value += "";
      value = value.replace(/۰/g, "0");
      value = value.replace(/۱/g, "1");
      value = value.replace(/۲/g, "2");
      value = value.replace(/۳/g, "3");
      value = value.replace(/۴/g, "4");
      value = value.replace(/۵/g, "5");
      value = value.replace(/۶/g, "6");
      value = value.replace(/۷/g, "7");
      value = value.replace(/۸/g, "8");
      value = value.replace(/۹/g, "9");
      return value;
    }
    getListFilterDate(date){
      if (this.isBlank(date) || this.isNull(date)) return this.getFormatedDateForDatePicker(null);
      //موقع لود در فرمت تاریخ نیست و بایستی تبدیل بشه
      if((typeof date) === "string")
        return this.getFormatedDateForDatePicker(this.gFormat(new Date(parseInt(date)),3));
      else
        return this.getFormatedDateForDatePicker(date);
    }
    showToast(_msg, _type) {
      //https://www.npmjs.com/package/react-toastify#demo
      if (_type=="success")
        toast.success(_msg);
      if (_type=="warning")
        toast.warn(_msg);
      if (_type=="danger")
        toast.error(_msg);
    }   
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
      });
    }
    //این تابع تبدیل نام عکس به مسیر کامل فایل عکس رو انجام میده
    toImageUrl(record,record_type,isThumnails=false)
    {
      //let prefix = 'https://civilica.com';
      let prefix = '';

      if(record === null || record === undefined) return "";
      if (record_type === 'keyword'){
        return prefix + "/images/subjects/" + record.id + ".png";
      }
      if (record_type === 'post')
      {
          if (record.post_type === 1 || record.post_type === 2)
          {
            if (record.ImageLink.includes("/images/"))
              return prefix + record.ImageLink;
            else
              return "/media/p/" + record.ImageLink;
          }
          if (record.post_type === 3)
          {
            if (record.Confrence === null)
              return prefix + record.ImageLink;
            else
            {
              if (record.Confrence.cover.includes("/images/"))
                return prefix + record.Confrence.cover;
              else
                return "/media/l/" + record.Confrence.cover;
            }
          }
      }
      if(record_type === 'staff')
      {
        if (record.pic === null || record.pic === "" || record.pic === undefined)
          return "/assets/images/no-pic.gif";
        return "/media/s/" + record.pic;
      }
      if(record_type === 'legal_person')
      {
        if(record.logo === null || record.logo === undefined || record.logo === "") return "/images/calendar/blank_conf.png";
        //is old path format
        if (record.logo.includes("/images/"))
          return prefix + record.logo;
        else
          return "/media/lo/"+record.logo;
      }
      if(record_type === 'legal_person_cover')
      {
        if(record.cover === null || record.cover === undefined || record.cover === "") return "/images/calendar/blank_conf.png";

        if (record.cover.includes("data:image/")) return record.cover;

        //is old path format
        if (record.cover.includes("/images/"))
        {
          if (!isThumnails)
            return prefix + record.cover;
          else
            return prefix + record.cover.split(".")[0] + "_tn." + record.cover.split(".")[1];
        }
        else
        {
          if (!isThumnails)
            return "/media/l/" + record.cover;
          else
            return "/media/l/" + record.cover.split(".")[0] + "_tn." + record.cover.split(".")[1];
        }
      }
      if(record_type === 'real_person')
      {
        if (record.pic === null || record.pic === "" || record.pic === undefined) return "/assets/images/no-pic.gif"; 
        if (record.pic.includes("/images/"))
          return prefix + record.pic;
        else
          return "/media/r/"+record.pic;
      }
      if (record_type === 'paper')
      {
        if (record.LegalPerson !== null)
        {
          if (record.LegalPerson.cover.includes("/images/"))
            return prefix + record.LegalPerson.cover;
          else
          {
            if(record.LegalPerson.cover === null || record.cover === undefined || record.cover === "") return "/assets/images/calendar/blank_conf.png";
            return "/media/l/" + record.LegalPerson.cover;
          }
        }
        else
          return "/assets/images/calendar/blank_conf.png";
      }
    }
    //اشتراکی شهر و استان
    loadProvincesOptions() {
      let items = [];
      let provinces = [];
      if (this.state.form_data !== undefined)
        provinces = this.state.form_data.provinces;
      if (this.state.data !== undefined)
        provinces = this.state.data.provinces;

      provinces.map(hit =>
          items.push({ value: hit.provinceId, label: hit.persianProvinceName })
      );
      return items;
    };
    bindCityFromProvince(e){    
      fetch("/ajax/cites/", {
        method: 'POST',
        body: JSON.stringify({
          "province_id": e.value
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(cites => {
        this.setState({cites})
      });
    }
    loadCityOptions() {
      let items = [];
      this.state.cites.map(hit =>
          items.push({ value: hit.cityId, label: hit.persianCityName })
      );
      return items;
    };
    //اشتراکی شهر و استان
    
  }
  export default Core;